import { Box, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import image from "../assets/images/24.png";

// Wrapping Chakra UI's Box with framer-motion for animation
const MotionBox = motion(Box);

const MainBanner = () => {
  const { t } = useTranslation();

  return (
    <Box
      position="relative"
      width="100%"
      overflow="hidden"
      mb={4}
      borderRadius="md" // Matching card roundedness
      boxShadow="lg" // Adding subtle shadow like the cards
    >
      {/* Image Component with Subtle Zoom Animation */}
      <MotionBox
        initial={{ scale: 1.05 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
        width="100%"
        height={{ base: "45vh", md: "40vh", sm: "50vh" }} // Further reduced height for compactness
        borderRadius="md" // Ensuring rounded corners for the image
        overflow="hidden"
      >
        <Image
          src={image}
          alt="Descriptive Alt Text"
          fit="cover"
          width="100%"
          height="100%"
          display="block"
        />
      </MotionBox>

      {/* Subtle Filter Layer for Readability */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0, 0, 0, 0.4)"
        backdropFilter="blur(2px)" // Subtle blur for readability
        borderRadius="md" // Rounded corners for the overlay
        zIndex={1}
      />

      {/* Text Content with Animation */}
      <MotionBox
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={2}
        color="white"
        textAlign="center"
        padding={{ base: "0.3rem", md: "0.6rem" }} // More compact padding
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        margin="0 auto"
        width={{ base: "95%", md: "75%", sm: '100%' }}
      >
        <Heading
          as="h1"
          fontSize={{ base: "md", md: "lg", lg: "xl" }} // Adjusted font sizes
          mb={{ base: 1, md: 2 }} // Reduced margin below heading
        >
          {t("mainBannerHeading")}
        </Heading>
        <Text
          fontSize={{ base: "sm", md: "md", lg: "lg" }}
          mb={3} // Reduced margin below text
        >
          {t("mainBannerText")}
        </Text>
      </MotionBox>
    </Box>
  );
};

export default MainBanner;
